import AppInit from './AppInit';

export default AppInit;
